{
  "DeleteReminder": "リマインダーを削除",
  "DismissAlert": "了解",
  "DismissAllReminders": "すべてのリマインダーを解除",
  "DismissReminder": "リマインダーを解除",
  "EditReminder": "リマインダーを編集",
  "RemindMe15Min": "15 分後に通知",
  "RemindMe5Min": "5 分後に通知",
  "RemindMe60Min": "1 時間後に通知",
  "RemindMeTomorrow": "明日通知",
  "Reminder": "リマインダー",
  "Reminders": "リマインダー",
  "SetReminder": "{formattedReminderTime} のリマインダー設定",
  "Snooze": "後で通知する"
}
